import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { Subscription } from 'rxjs';
import { FilterFieldComponent } from '../filter-field.component';
import { RadioFilterField } from './filter-field-radio';

@Component({
  selector: 'va-filter-radio',
  template: `
    <mat-radio-group class="radio-group" [(ngModel)]="selectedRadio">
      @for (radio of filterField.options; track radio) {
        <mat-radio-button
          class="radio-button"
          [value]="radio.id"
          (change)="radioChange($event)"
          >
          {{ '' + radio.name | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>
    `,
  styleUrls: ['filter-field-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RadioFilterFieldComponent extends FilterFieldComponent<RadioFilterField> implements OnInit, OnDestroy {
  selectedRadio: string;
  private sub: Subscription;

  // If RadioFilterField.changeValue called from a class Outside the `RadioFilterFieldComponent`
  // we need to push that value change to parent components, and update the the current instance
  // to reflect the correct value.
  private updateValue = () => {
    this.selectedRadio = this.filterField.value!.id;
    this.applyFilter(this.filterField.value);
  };

  ngOnInit(): void {
    if (this.filterField.value) {
      this.updateValue();
    }

    this.sub = this.filterField.valueChanged$.subscribe(this.updateValue);
  }

  radioChange(event: MatRadioChange): void {
    const newValue = this.filterField.options.find((v) => v.id === event.value);
    this.filterField.changeValue(newValue);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  applyFilter(value: any): void {
    this.filterApplied.emit(this.filterField);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
